import styled from 'styled-components'

export const AnimationWrap = styled.div`
  position: relative;
  overflow: hidden;
`
